import { coreApi } from "../client";
import { PAYROLL } from "../endpoints";

export const getCorporations = async () => {
  const res = await coreApi.get(PAYROLL.CORPORATIONS, {
    params: { IsShowAll: false },
  });
  return res.data?.Corporations || [];
};

const accountsCache = new Map();
const inFlightAccountPromises = new Map();

export const clearAccountsCache = (corpId) => {
  if (corpId) {
    for (const key of accountsCache.keys()) {
      if (key.startsWith(`${corpId}_`)) {
        accountsCache.delete(key);
      }
    }
  } else {
    accountsCache.clear();
  }
};

export const getAccounts = async (
  corpId,
  accountTypeId = "000000000000000000000000000000000000",
  forceRefresh = false
) => {
  if (!corpId || corpId === "000000000000000000000000000000000000") {
    return [];
  }

  const cacheKey = `${corpId}_${accountTypeId || "000000000000000000000000000000000000"}`;

  if (!forceRefresh && accountsCache.has(cacheKey)) {
    return accountsCache.get(cacheKey);
  }

  if (!forceRefresh && inFlightAccountPromises.has(cacheKey)) {
    return inFlightAccountPromises.get(cacheKey);
  }

  const fetchPromise = (async () => {
    try {
      const res = await coreApi.get(PAYROLL.ACCOUNTS, {
        params: {
          AccountTypeID: accountTypeId,
          IsInactive: false,
          CorpID: corpId,
        },
      });

      const data = (res.data?.Accounts || []).map((acc) => ({
        label: acc.Name,
        value: acc.ID,
        id: acc.ID,
        type: acc.AccountTypeName,
      }));

      accountsCache.set(cacheKey, data);
      return data;
    } finally {
      inFlightAccountPromises.delete(cacheKey);
    }
  })();

  inFlightAccountPromises.set(cacheKey, fetchPromise);
  return fetchPromise;
};

let inFlightDeptPromise = null;

export const getDepartments = async () => {
  if (inFlightDeptPromise) {
    return inFlightDeptPromise;
  }

  inFlightDeptPromise = (async () => {
    try {
      const res = await coreApi.get(PAYROLL.DEPARTMENTS);
      return (res.data?.DeptList || []).map((d) => ({
        label: d.DeptName,
        value: d.ID,
      }));
    } finally {
      inFlightDeptPromise = null;
    }
  })();

  return inFlightDeptPromise;
};

let inFlightJobTitlesPromise = null;

export const getJobTitles = async () => {
  if (inFlightJobTitlesPromise) {
    return inFlightJobTitlesPromise;
  }

  inFlightJobTitlesPromise = (async () => {
    try {
      const res = await coreApi.get(PAYROLL.JOB_TITLES);
      return (res.data?.JobTitleResp || []).map((j) => ({
        label: j.JobTitle,
        value: j.ID,
        desc: j.Description,
      }));
    } finally {
      inFlightJobTitlesPromise = null;
    }
  })();

  return inFlightJobTitlesPromise;
};
